import { CheckboxField } from '@cian/components';
import * as React from 'react';

import { EFacility } from '../../../../../../../json_query/types';
import { FDealType, FOfferType, isUrban } from '../../../../../../../utils/category';
import * as styles from './facilities.css';

export interface IFacilitiesProps {
  dealType: FDealType;
  offerType: FOfferType;

  facilities: EFacility[];

  onChange(facility: EFacility, value: boolean | undefined): void;
}

interface IFacility {
  name: string;
  type: EFacility;
}

const FACILITIES: IFacility[][] = [
  [
    { name: 'Кухонная мебель', type: EFacility.KitchenFurniture },
    { name: 'Холодильник', type: EFacility.Fridge },
    { name: 'Посудомоечная машина', type: EFacility.Dishwasher },
    { name: 'Стиральная машина', type: EFacility.Washer },
  ],
  [
    { name: 'Комнатная мебель', type: EFacility.RoomFurniture },
    { name: 'Интернет', type: EFacility.Internet },
    { name: 'Телевизор', type: EFacility.TV },
    { name: 'Кондиционер', type: EFacility.Conditioner },
  ],
];

const HOUSE_FACILITIES: IFacility[] = [
  { name: 'Баня', type: EFacility.Sauna },
  { name: 'Гараж', type: EFacility.Garage },
  { name: 'Бассейн', type: EFacility.Pool },
];

const SALE_HOUSE_FACILITIES: IFacility[] = [{ name: 'Охрана', type: EFacility.Security }];

export const Facilities: React.StatelessComponent<IFacilitiesProps> = props => (
  <div className={styles['container']}>
    {getFacilities(props.dealType, props.offerType).map((column, index) => (
      <div key={`column_${index}`} className={styles['column']}>
        {column.map(facility => (
          <CheckboxField
            key={`facility_${facility.name}`}
            onValueChange={value => props.onChange(facility.type, value)}
            value={props.facilities.includes(facility.type)}
            label={facility.name}
          />
        ))}
      </div>
    ))}
  </div>
);

export function getFacilities(dealType: FDealType, offerType: FOfferType): IFacility[][] {
  if (dealType === FDealType.Sale) {
    if ((offerType & (FOfferType.Suburban & ~FOfferType.Land)) !== 0) {
      return [HOUSE_FACILITIES.concat(SALE_HOUSE_FACILITIES)];
    }
  } else {
    if (isUrban(offerType)) {
      return FACILITIES;
    } else if ((offerType & (FOfferType.Suburban & ~FOfferType.Land)) !== 0) {
      return FACILITIES.concat([HOUSE_FACILITIES]);
    }
  }

  return [];
}
